import type { SupportedLanguage } from "@acme/i18n";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const LANGUAGE_STORAGE_KEY = "clashops-language";

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState<SupportedLanguage>("en");

  // Initialize language from localStorage or browser preference
  useEffect(() => {
    const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY) as SupportedLanguage;

    if (storedLanguage && ["en", "de", "fr"].includes(storedLanguage)) {
      setCurrentLanguage(storedLanguage);
      i18n.changeLanguage(storedLanguage);
    } else {
      // Fallback to browser language or default to English
      const browserLanguage = navigator.language.split("-")[0] as SupportedLanguage;
      const fallbackLanguage = ["en", "de", "fr"].includes(browserLanguage) ? browserLanguage : "en";

      setCurrentLanguage(fallbackLanguage);
      i18n.changeLanguage(fallbackLanguage);
      localStorage.setItem(LANGUAGE_STORAGE_KEY, fallbackLanguage);
    }
  }, [i18n]);

  const changeLanguage = (newLanguage: SupportedLanguage) => {
    setCurrentLanguage(newLanguage);
    i18n.changeLanguage(newLanguage);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, newLanguage);
  };

  return {
    currentLanguage,
    changeLanguage,
  };
};
